import { Alert, HFlow, Text, VFlow } from 'bold-ui'
import { ReactComponent as Relatorio } from 'images/side-menu/relatorios.svg'
import React from 'react'

import gifGovbr from '../../images/novidades/gif_govbr.gif'
import { NewsHeadingSection } from './NewsHeadingSection'

export function NewsInternalPanelV4_40() {
  if (!process.env.REACT_APP_VERSION) {
    return (
      <Alert type='danger' inline>
        Nenhuma informação sobre versões anteriores está disponível.
      </Alert>
    )
  }

  return (
    <VFlow>
      <VFlow vSpacing={1}>
        <Text fontWeight='bold'>Módulos com novidades:</Text>
        <HFlow hSpacing={5}>
          <VFlow vSpacing={0.2}>
            <Text component='li'>Login via Gov.br</Text>
          </VFlow>
        </HFlow>
        <NewsHeadingSection
          title='Login via Gov.br'
          icon={<Relatorio style={{ marginRight: '0.25rem', width: '32px', height: '32px' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>A partir da versão 4.4.0 será possível fazer o login via Gov.br.</Text>
            <img src={gifGovbr} style={{ width: '100%' }} alt='Gif login govbr' />
          </VFlow>
        </NewsHeadingSection>
      </VFlow>
    </VFlow>
  )
}
